import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DISPLAY_DATE_FORMAT, IconNames } from '../../../../common';
import { LatestNotification } from '../../../../store';

@Component({
  selector: 'ui-latest-notification',
  templateUrl: './latest-notification.component.html',
  styleUrls: ['./latest-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LatestNotificationComponent {
  @Input() latestNotification: LatestNotification;

  // TODO remove after DN/HU implementation
  @Input() isTimezoneAvailable = true;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
